import { format } from 'date-fns';
import { apiClient } from 'c-data';
import type { DisplayMediaBreakdownData } from 'c-sdk';
import type { ReportConfig } from 'c-reports/Types';
import { ReportDateTimeframe } from 'c-reports/Types';

type FetchData = ReportConfig<{ data: DisplayMediaBreakdownData[] }>['fetchData'];

/**
 * A report `fetchData` for a channel frame's media breakdown. `All` sends one unbounded request;
 * any other timeframe sends one bounded by the report's start and end days.
 */
export const channelFrameMediaBreakdownFetcher =
    (channelFrameId: number, mediaItems: string[]): FetchData =>
    (start, end, timeframe, group_by) => {
        if (timeframe === ReportDateTimeframe.All) {
            return apiClient.PopDisplays.channelFrameMediaBreakdown(channelFrameId, {
                media_items: mediaItems,
                group_by,
            });
        }
        return apiClient.PopDisplays.channelFrameMediaBreakdown(channelFrameId, {
            start_date: start ? `${format(start, 'yyyy-MM-dd')} 00:00:00` : undefined,
            end_date: end ? `${format(end, 'yyyy-MM-dd')} 23:59:59` : undefined,
            media_items: mediaItems,
            group_by,
        });
    };
